/*jshint esnext: true */
/*global jQuery, dis */

/* AKQA Script
 Author's name: Dan Sørensen
 Modified by:
 Client name: Danske Regioner
 Date of creation: 19.3.2021
 */


(function ($, dis) {
	"use strict";


	dis.OkportalNumerisk = function (objectConfiguration) {
		dis.BaseModule.call(this);

		var defaults = {},
			configuration = $.extend(defaults, objectConfiguration),
			dom = {},
			selfScope = this;


		function init() {
			dom.container = $(configuration.container);

			if (dom.container.length > 0) {

				dom.headline = $("#okportal-numerisk__headline");

				dom.profileLink = $(".okportal__profile-link");
				dom.memberId = dom.profileLink.data("memberid");

				dom.noCollectionIdErrorMessagde = "Der mangler et collectionName, ellers findes der ikke nogen overenskomstsamling med det given navn";
				dom.numeriskResultsList = dom.container.find(".okportal-numerisk__resultsList");
				dom.searchBtn = dom.container.find(".okportal-searchbar__btn");
				dom.collectionNodes = null;
				dom.areaNodes = null;
				dom.paramsForWindowHistoryState = {};

				dom.documentList = [];

				//To do change this to link parameters from search copy
				dom.params = {
					areaid: selfScope.getUrlParameter('areaid'),
					subareaid: selfScope.getUrlParameter('subareaid'),
					agreementid: selfScope.getUrlParameter('agreementid'),
					collectionName: selfScope.getUrlParameter('collectionName'),
				};

				selfScope.handleCollectionName();
				// for testing url: ?collectionName=Praksis&areaid=28367&subareaid=28370&agreementid=28373


				if (dom.params.areaid !== false && dom.params.subareaid !== false && dom.params.agreementid !== false) {

					//set current params
					dom.paramsForWindowHistoryState.areaid = dom.params.areaid;
					dom.paramsForWindowHistoryState.subareaid = dom.params.subareaid;
					dom.paramsForWindowHistoryState.agreementid = dom.params.agreementid;

					// Insert nodes based on to params
					selfScope.getAreaNodes(null, false, dom.params.areaid, true);

					// getFavourites and then getSubareaNodes
					// Getting Favourites data
					if (dom.memberId !== undefined) {
						selfScope.getFavourites(() => {

						});
					} else {
						selfScope.getSubareaNodes(null, dom.params.subareaid, true, () => {

						});
					}

				} else if (dom.params.areaid !== false && dom.params.subareaid !== false && dom.params.agreementid === false) {
					//set current params
					dom.paramsForWindowHistoryState.areaid = dom.params.areaid;
					dom.paramsForWindowHistoryState.subareaid = dom.params.subareaid;

					// Insert nodes based on to params
					selfScope.getAreaNodes(null, false, dom.params.areaid, true);

					// Getting Favourites data
					if (dom.memberId !== undefined) {
						selfScope.getFavourites();
					} else {
						selfScope.getSubareaNodes(null, dom.params.subareaid, true);
					}

				} else if (dom.params.areaid !== false && dom.params.subareaid === false && dom.params.agreementid === false) {
					//set current params
					dom.paramsForWindowHistoryState.areaid = dom.params.areaid;

					// Insert nodes based on to params
					selfScope.getAreaNodes(null, false, dom.params.areaid, true);
				} else {
					if (dom.params.collectionName === false && dom.paramsForWindowHistoryState.collectionName === null) {
						dom.numeriskResultsList.append(dom.noCollectionIdErrorMessagde);
					} else {
						selfScope.getCollectionNodes();
					}
				}
			}
		}

		//first step
		selfScope.getCollectionNodes = function (urlp = "") {

			//clear numerisk Results List
			$(dom.numeriskResultsList).empty();

			let url = `${location.origin}/umbraco/api/okportalcontent/GetCollectionNodes?collectionName=${dom.paramsForWindowHistoryState.collectionName}`;
			if (urlp !== "") {
				url = urlp;
			}

			// Send data from filters to web service
			dom.numeriskResultsList.addClass("-is-loading");
			if (dom.collectionNodes !== null) {
				selfScope.appendCollectionNodes(dom.collectionNodes);
				dom.numeriskResultsList.removeClass("-is-loading");
			} else {
				$.ajax(url, {
					method: "GET",
					cache: false,
					success: function (response) {

						dom.filteredResponse = selfScope.filterCollectionNodes(response);
						dom.collectionNodes = dom.filteredResponse;
						// Put new list of articles in DOM
						selfScope.appendCollectionNodes(dom.collectionNodes);

						dom.numeriskResultsList.removeClass("-is-loading");
					},
					error: function () {
						dom.numeriskResultsList.removeClass("-is-loading");
						dom.numeriskResultsList.append(dom.noCollectionIdErrorMessagde);
					}
				});
			}

			// Adding only collectionName for parameters.
			selfScope.SetWindowHistoryState();
		};
		selfScope.filterCollectionNodes = function (items) {
			return items.sort((a, b) => parseInt(a.number) < parseInt(b.number) ? -1 : 1);
		};
		selfScope.templatingCollectionNodes = function (item) {

			return selfScope.templating('' +
				'<li>' +
				'<button class="okportal-numerisk__item-btn" data-areaid="{{id}}">' +
				'{{number}} -{{heading}}' +
				'<span class="icon"><svg role="img" aria-label="pil til højre"><use xlink:href="/static/dist/icons.svg#arrow-right-big"></use></svg></span>' +
				'</button>' +
				'</li>'.toString(), {
				id: item.id,
				number: item.number,
				heading: item.name,
			});
		};
		selfScope.appendCollectionNodes = function (response) {
			if (response !== null) {
				response.forEach(function (element) {
					dom.numeriskResultsList.append(selfScope.templatingCollectionNodes(element));
				});
			}

			if (response.length === 1) {
				selfScope.getAreaNodes(null, false, response[0].id);
			}

			dom.okportalNumeriskCollectionNodeBtns = dom.container.find(".okportal-numerisk__item-btn").not(".okportal-numerisk__item-subarea");
			dom.okportalNumeriskCollectionNodeBtns.on("click", e => selfScope.getAreaNodes(e));

		};


		//second step
		selfScope.handleBackToOverviewCollectionNodes = function () {

			delete dom.paramsForWindowHistoryState.areaid;
			selfScope.SetWindowHistoryState();
			selfScope.getCollectionNodes();
		};

		selfScope.getAreaNodes = function (e = null, back = false, pareaid = null, stopChangingParameters = false) {

			//clear numerisk Results List
			const areaid = (e !== null ? e.currentTarget.dataset.areaid : pareaid);

			// Send data from filters to web service
			dom.numeriskResultsList.addClass("-is-loading");
			if (back) {
				dom.filteredResponse = dom.areaNodes;
				$(dom.numeriskResultsList).empty();
				selfScope.appendAreanodes();

				dom.numeriskResultsList.removeClass("-is-loading");
			} else {
				$.ajax(`${location.origin}/umbraco/api/okportalcontent/getareanodes?id=${areaid}`, {
					method: "GET",
					cache: false,
					async: false,
					success: function (response) {
						dom.filteredResponse = response;
						dom.filteredResponse.subareas = selfScope.filterAreaNodes(response.subareas);
						// save areanodes to be able to go back.
						dom.areaNodes = dom.filteredResponse;
						$(dom.numeriskResultsList).empty();
						selfScope.appendAreanodes();

						dom.numeriskResultsList.removeClass("-is-loading");
					}
				});
			}

			// Adding areaid for parameters.
			if (!stopChangingParameters) {
				delete dom.paramsForWindowHistoryState.subareaid;
				delete dom.paramsForWindowHistoryState.agreementid;
				dom.paramsForWindowHistoryState.areaid = areaid;
				selfScope.SetWindowHistoryState();
			}
		};
		selfScope.filterAreaNodes = function (subareas) {

			return subareas.sort((a, b) => parseInt(a.number) < parseInt(b.number) ? -1 : 1);
		};
		selfScope.templatingAreaNodes = function (item) {
			const area = item.area,
				subareas = item.subareas;

			var documentsHtml = "";
			subareas.forEach(function (subarea) {
				documentsHtml = documentsHtml + selfScope.templatingSubareasNodes(subarea);
			});

			return selfScope.templating('' +
				'<li>' +
				'<button class="okportal-numerisk__item-btn -is-open" data-areaid="{{id}}">' +
				'{{number}} - {{heading}}' +
				'<span class="icon"><svg role="img" aria-label="pil til højre"><use xlink:href="/static/dist/icons.svg#arrow-right-big"></use></svg></span>' +
				'</button>' +
				'<ul class="okportal-search okportal-numerisk__subarea-list">' +
				documentsHtml +
				'</ul>' +
				'</li>'.toString(), {
				id: area.id,
				number: area.number,
				heading: area.name,
			});
		};
		selfScope.templatingSubareasNodes = function (subarea) {


			return selfScope.templating('' +
				'<li>' +
				'<button class="okportal-numerisk__item-btn okportal-numerisk__item-subarea" data-subareaid="{{id}}">' +
				'{{number}} - {{heading}}' +
				'<span class="icon"><svg role="img" aria-label="pil til højre"><use xlink:href="/static/dist/icons.svg#arrow-right-big"></use></svg></span>' +
				'</button>' +
				'</li>'.toString(), {
				id: subarea.id,
				number: subarea.number,
				heading: subarea.name,
			});
		};
		selfScope.appendAreanodes = function () {
			if (dom.filteredResponse !== null) {

				dom.backToOverview = selfScope.templating('' +
					'<button class="okportal-search__load-more-btn okportal-numerisk__backToOverviewBtn">' +
					'<span class="okportal-search__load-more-btn-icon"><svg role="img" aria-label="Vis flere resultater icon"><use xlink:href="/static/dist/icons.svg#arrow-right-small"></use></svg></span>' +
					'Oversigt</button>'.toString(), {});

				dom.numeriskResultsList.append(dom.backToOverview);
				dom.numeriskResultsList.append(selfScope.templatingAreaNodes(dom.filteredResponse));
			}

			//back to overview btn
			selfScope.handleBackToOverviewBtn();

			//To make next step buttons
			selfScope.handleSubareaBtns();

			//Subarealist used to append documents
			selfScope.handleDomItemSubareaList();
		};


		//third step
		// Function for fav
		selfScope.getFavourites = function (callback = null, url = "", e = null) {

			const urltest = `${location.origin}/umbraco/api/OkPortalFavourites/GetFavourites/?memberId=${dom.memberId}`;
			if (urltest !== "") {
				url = urltest;
			}

			const promise = Promise.resolve($.ajax({
				url: url
			}));

			promise.then(data => {
				dom.favData = data;
				selfScope.getSubareaNodes(e, dom.params.subareaid);
			}).then(() => {
				if (typeof callback === "function") {
					callback();
				}

				dom.okportalNumeriskSubareaBtns.parent().removeClass("-is-loading");

			}).catch(error => window.console.log(error));
		};


		selfScope.setFavourite = function (contentId, url = "") {

			const urltest = `${location.origin}/umbraco/api/OkPortalFavourites/AddFavourite/?contentId=${contentId}&memberId=${dom.memberId}`;
			if (urltest !== "") {
				url = urltest;
			}

			return Promise.resolve($.ajax({
				url: url,
				type: "POST",
			}));
		};
		selfScope.removeFavourite = function (rowId, url = "") {

			const urltest = `http://localhost:53221/umbraco/api/OkPortalFavourites/RemoveFavourite/?id=${rowId}`;
			if (urltest !== "") {
				url = urltest;
			}

			return Promise.resolve($.ajax({
				url: url,
				type: "DELETE",
			}));
		};

		selfScope.handleBackToOverviewAreaNodes = function (e) {
			selfScope.getAreaNodes(e, true);
		};
		selfScope.handleRadioButtonsParameters = function (e) {
			const element = $(e.currentTarget);
			if (element.is(':checked')) {
				// Adding agreementsId for parameters.
				const agreementsId = element.attr("id");
				dom.paramsForWindowHistoryState.agreementid = agreementsId;
				if (agreementsId === undefined) {
					delete dom.paramsForWindowHistoryState.agreementid;
				}
				selfScope.SetWindowHistoryState();
			}
		};

		selfScope.getSubareaNodes = function (e = null, psubareaid = null, stopChangingParameters = false, callback = null) {

			// If comming from url event has not been set for BackToOverviewBtn and dom element for ItemSubareaList
			if (dom.okportalNumeriskBackToOverviewBtn === undefined) {
				selfScope.handleBackToOverviewBtn();
				selfScope.handleDomItemSubareaList();
			}

			// Clear numerisk Results List
			const subareaid = (e !== null ? e.currentTarget.dataset.subareaid : psubareaid),
				currentItem = $(dom.okportalNumeriskSubareaList).find(`[data-subareaid='${subareaid}']`),
				currentItemParent = $(dom.okportalNumeriskSubareaList).find(`[data-subareaid='${subareaid}']`).parent("li"),
				siblings = currentItemParent.siblings(),
				parentItem = $(currentItemParent).parents("li"),
				parentItemBtn = $(parentItem).find("> .okportal-numerisk__item-btn");


			// Add active class on pressed item
			$(currentItem).addClass("-is-active");
			$(parentItem).addClass("-is-active");
			parentItemBtn.addClass("back-to-area-btn");

			// Adding breadcrumbs button after the overview back button
			dom.okportalNumeriskBackToOverviewBtn.after("/ <button class=\"okportal-search__load-more-btn okportal-numerisk__backToOverviewBtn back-to-area-btn\">" + parentItemBtn[0].innerText + "</button>");

			// loading new data and running the append function
			dom.numeriskResultsList.addClass("-is-loading");
			$.ajax(`${location.origin}/umbraco/api/okportalcontent/getsubareanodes?id=${subareaid}`, {
				method: "GET",
				cache: false,
				async: false,
				success: function (response) {
					dom.filteredResponse = selfScope.filterDocumentsInSubareaNodes(response.agreements);
					// Remove all other items than the clicked
					siblings.remove();

					// Adding clicked item documents
					selfScope.appendSubareaNodesDocuments();

					// Remove item btn event so you cant get the subareanodes you are already on
					$(currentItem).off();

					dom.numeriskResultsList.removeClass("-is-loading");
					$(".-is-loading").removeClass("-is-loading");


					selfScope.openAgrementWithUrl();
				}
			});

			// Adding subareaid for parameters.
			if (!stopChangingParameters) {
				dom.paramsForWindowHistoryState.subareaid = subareaid;
				selfScope.SetWindowHistoryState();
			}
		};
		selfScope.filterDocumentsInSubareaNodes = function (items) {

			console.log("items",items)
			const currentDate = new Date();

			let result = [];

			$.each(items, function () {
				const currentDocuments = $(this)[0].documents;
				if(currentDocuments === null)
					return;
				console.log(currentDocuments);
				const activeDocuments = currentDocuments.reduce(function (result, item) {

					const itemValidFromDate = new Date(item.validFrom);
					const itemValidToDate = new Date(item.validTo);

					if (selfScope.isValidDate(itemValidFromDate)) {
						//check if item has a valid to date if not it must be a active item, so just check if the current date is after the from date, then we know the to date isn't set yet.
						if (!selfScope.isValidDate(itemValidToDate)) {
							if (currentDate.getTime() > itemValidFromDate.getTime()) {
								result.push(item);
							}
						}
						else
						{
							// And if the item has a to date then check if the item is between the two dates.
							if (currentDate.getTime() > itemValidFromDate.getTime() && currentDate.getTime() < itemValidToDate.getTime()) {
								result.push(item);
							}
						}
					}
					return result;
				}, []);

				const futureDocuments = currentDocuments.reduce(function (result, item) {

					const itemValidFromDate = new Date(item.validFrom);

					if (selfScope.isValidDate(itemValidFromDate)) {
						if (currentDate.getTime() < itemValidFromDate.getTime()) {
							result.push(item);
						}
					}
					return result;
				}, []);

				const historyDocuments = currentDocuments.reduce(function (result, item) {

					const itemValidFromDate = new Date(item.validFrom);
					const itemValidToDate = new Date(item.validTo);

					if (selfScope.isValidDate(itemValidFromDate)) {
						if (selfScope.isValidDate(itemValidToDate)) {
							if (currentDate.getTime() > itemValidFromDate.getTime() && currentDate.getTime() > itemValidToDate.getTime()) {
								result.push(item);
							}
						}
					}
					return result;
				}, []);


				result = activeDocuments.concat(futureDocuments).concat(historyDocuments);

				$(this)[0].documents = result;
			});

			return items;
		};
		selfScope.templatingSubareaDocumentWrapperItem = function (item) {

			let hasItemAsFav = false,
				currentFavItem = null;

			if (!jQuery.isEmptyObject(dom.favData)) {
				// reduce to only current fav item
				currentFavItem = dom.favData.reduce(function (result, reduceItem) {
					if (reduceItem.contentId === item.contentNodeId) {
						result = reduceItem;
					}
					return result;
				}, {});

				if (!jQuery.isEmptyObject(currentFavItem)) {
					hasItemAsFav = true;
				}
			}

			// dom.documentList

			let documentsHtml = "";
			let currentDocumentListIndex = dom.documentList.push(item.documents) - 1;

			currentDocumentListIndex = (currentDocumentListIndex === null ? 0 : currentDocumentListIndex);
			// item.documents.forEach(function (document) {
			// 	documentsHtml = documentsHtml + selfScope.templatingDocumentItem(document);
			// });

			return selfScope.templating('' +
				'<li>' +
				'<div class="accordion-box__content" >' +
				'<div class="accordion-box__content__item">' +
				'<input type="radio" name="accordion-{{id}}" id="{{id}}">' +
				'<label class="accordion-box__content__item__head" data-documentListId="{{currentDocumentListIndexNr}}" for="{{id}}">' +
				'<p class="item__placement"><span>Placering i indholdsfortegnelse: </span>{{mainAreaNumber}}</p>' +
				'<h2 class="item__heading">{{heading}}</h2>' +
				'<span class="icon"><svg role="img" aria-label="Op ned pil"><use xlink:href="/static/dist/icons.svg#arrow-down"></use></svg></span>' +
				'<label><input type="radio" name="accordion-{{id}}"></label>' +
				'</label>' +
				'<div class="accordion-box__content__item__body">' +
				'<div class="accordion-box__content__item__body__inside document__wrapper">' +
				'<div class="document">' +
				'<div class="document__actions">' +
				'<div class="document__actions-col1">' +
				(item.otherMaterial ? '<button class="document__actions-showOtherMaterial" data-agreementid="{{id}}"><span class="text">Vis andet relevant materiale</span><span class="icon"><svg role="img" aria-label="Op ned pil"><use xlink:href="/static/dist/icons.svg#arrow-down"></use></svg></span></button>' : '') +
				'<div class="materials-container"></div></div>' +
				'<div class="document__actions-col2"><button class="document__actions-copyLink">Kopier link' +
				'<svg role="img" aria-label="Kopier link ikon"><use xlink:href="/static/dist/icons.svg#link"></use></svg>' +
				'<span class="document__actions-copyLink-checkmark"><svg role="img" aria-label="Kopier link ikon checkmark"><use xlink:href="/static/dist/icons.svg#checkmark"></use></svg></span>' +
				'</button>' +
				(dom.memberId !== undefined ? '' +
					'<button data-contentid="{{id}}" data-rowid="{{rowId}}" class="document__actions-addFavorites ' + (hasItemAsFav ? "-is-faved" : "") + '" >' +
					'<span class="add-text">Tilføj favoritter</span><span class="remove-text">Fjern favoritter</span><svg role="img" aria-label="Tilføj til favoritter ikon"><use xlink:href="/static/dist/icons.svg#heart-like"></use></svg><svg role="img" aria-label="Document er tilføjet favoritter ikon"><use xlink:href="/static/dist/icons.svg#heart-like-fill"></use></svg>' +
					'</button>' : '' +
					'<a class="document__actions-addFavorites login-button-modal open-modal" href="#login-form" >' +
					'Tilføj favoritter<svg role="img" aria-label="Tilføj til favoritter ikon"><use xlink:href="/static/dist/icons.svg#heart-like"></use></svg><svg role="img" aria-label="Document er tilføjet favoritter ikon"><use xlink:href="/static/dist/icons.svg#heart-like-fill"></use></svg>' +
					'</a>') +
				'</div>' +
				'</div>' +
				// documentsHtml +
				'</div>' +
				'</div>' +
				'</div>' +
				'</div>' +
				'</div>' +
				'</li>'.toString(), {
				id: item.contentNodeId,
				rowId: (currentFavItem !== null ? currentFavItem.id : ""),
				heading: item.name,
				mainAreaNumber: item.number,
				mainAreaHeadline: item.headline,
				areaNumber: item.areaNumber,
				areaHeadline: item.areaHeadline,
				currentDocumentListIndexNr: currentDocumentListIndex
			});
		};
		selfScope.templatingDocumentItem = function (item) {

			let mediaUrl = item.mediaUrl;
			console.log("mediaUrl ", item.mediaUrl)

			//format dates
			var validFromDate = new Date(item.validFrom);
			// getMonth counting from 0 so we have to add 1 to getMonth
			var validFromDateMonth = validFromDate.getMonth() + 1;
			var validFromDateFormated = (validFromDate.getDate() > 9 ? validFromDate.getDate() : '0' + validFromDate.getDate()) + "." + (validFromDateMonth > 9 ? validFromDateMonth : '0' + validFromDateMonth) + "." + validFromDate.getFullYear();

			var validToDate = new Date(item.validTo);
			// getMonth counting from 0 so we have to add 1 to getMonth
			var validToDateMonth = validToDate.getMonth() + 1;
			var validToDateFormated = (validToDate.getDate() > 9 ? validToDate.getDate() : '0' + validToDate.getDate()) + "." + (validToDateMonth > 9 ? validToDateMonth : '0' + validToDateMonth) + "." + validToDate.getFullYear();

			//active future or history
			var dateActivationTag = selfScope.getDateActivationText(validFromDate, validToDate);
			var activationTagText = (dateActivationTag === "--active" ? "Aktiv" : (dateActivationTag === "--history" ? "Historie" : "Fremtidig"));

			return selfScope.templating('' +
				'<div class="document__inner ' + dateActivationTag + '">' +
				'<div class="document__title"><h3>{{description}}</h3></div>' +
				// '<div class="document__description">{{description}}</div>' +
				// '<div class="document__type">' +
				// '<button class="document__type-btn btn -primary">{{type}}</button>' +
				// '</div>' +
				'<div class="document__dates-wrapper">' +
				'<label class="document__dates-tag ' + dateActivationTag + '">' + activationTagText + '</label>' +
				'<div class="document__dates">' +
				(selfScope.isValidDate(validFromDate) ? '' +
					'<div class="document__dates-validFrom">' +
					'<p class="document__dates-validFrom-labels">Gyldig fra :&nbsp;</p><p class="document__dates-validFrom-date">{{validFrom}}</p>' +
					'</div>' : '') +
				(selfScope.isValidDate(validToDate) ? '' +
					'<div class="document__dates-validTo">' +
					'<p class="document__dates-validTo-labels">Gyldig til :&nbsp;</p><p class="document__dates-validTo-date">{{validTo}}</p>' +
					'</div>' : '') +
				'</div>' +
				'</div>' +
				'<div class="document__download">' +
					'<a href="' + mediaUrl +'" target="_blank" class="document__download-link ' + dateActivationTag + '"><span class="document__download-text">Hent dokument</span><svg role="img" aria-label="Download pil"><use xlink:href="/static/dist/icons.svg#download"></use></svg></a>' +
				'</div>' +
				'</div>'.toString(), {
				description: item.description,
				title: item.name,
				type: item.type,
				validFrom: validFromDateFormated,
				validTo: validToDateFormated
			})
		};
		selfScope.appendSubareaNodesDocuments = function () {
			if (dom.filteredResponse !== null) {

				dom.filteredResponse.forEach(function (element) {
					//Add documents to count
					dom.okportalNumeriskSubareaList.append(selfScope.templatingSubareaDocumentWrapperItem(element));
				});
			}

			dom.okportalNumeriskItemBtn = dom.container.find(".back-to-area-btn");
			dom.okportalNumeriskItemBtn.on("click", e => selfScope.handleBackToOverviewAreaNodes(e));

			// Adding accordion id to parameter
			const radioButtons = dom.okportalNumeriskSubareaList.find("input[type=radio]");
			radioButtons.on("click", e => selfScope.handleRadioButtonsParameters(e));


			selfScope.handleOpeningAgreement();
			selfScope.handleCopyUrl();
			selfScope.handleFav();
			selfScope.handleOtherMaterial();
		};

		selfScope.SetWindowHistoryState = function () {

			const parameterStr = jQuery.param(dom.paramsForWindowHistoryState);
			window.history.pushState('Okportal numerisk', 'Okportal numerisk', `${location.origin}${location.pathname}?${parameterStr}`);
		};

		//Set if document is active
		selfScope.getDateActivationText = function (validFromDate, validToDate) {
			var currentDate = new Date();

			if (selfScope.isValidDate(validFromDate)) {
				if (currentDate.getTime() > validFromDate.getTime()) {
					if (validToDate.getTime() > currentDate.getTime() || !selfScope.isValidDate(validToDate)) {
						return '--active';
					} else {
						return '--history';
					}
				} else {
					return '--future';
				}
			} else if (selfScope.isValidDate(validToDate))//Future
			{
				if (validToDate.getTime() > currentDate.getTime()) {
					return '--active';
				} else {
					return '--history';
				}
			} else {
				return '--future';
			}
		};

		// Check if date is valid
		selfScope.isValidDate = function (d) {
			return d instanceof Date && !isNaN(d) && d.getTime() !== new Date("0001-01-01T00:00:00").getTime() && d.getTime() !== new Date("9999-12-31T23:59:59.9999999").getTime();
		};

		selfScope.handleBackToOverviewBtn = function () {
			//back to overview btn
			dom.okportalNumeriskBackToOverviewBtn = dom.container.find(".okportal-numerisk__backToOverviewBtn");
			dom.okportalNumeriskBackToOverviewBtn.on("click", () => selfScope.handleBackToOverviewCollectionNodes());
		};
		selfScope.handleSubareaBtns = function () {
			//To make next step buttons
			dom.okportalNumeriskSubareaBtns = dom.numeriskResultsList.find(".okportal-numerisk__item-subarea");
			dom.okportalNumeriskSubareaBtns.on("click", e => {
				$(e.currentTarget).closest("li").addClass("-is-loading");

				window.setTimeout(() => {
					// Getting Favourites data
					if (dom.memberId !== undefined) {
						selfScope.getFavourites(null, "", e);
					} else {
						selfScope.getSubareaNodes(e);
					}
				}, 100);

				window.setTimeout(() => {
					if (dom.numeriskResultsList.offset().top < document.documentElement.scrollTop) {
						$("html, body").animate({
							scrollTop: dom.numeriskResultsList.offset().top
						}, 500);
					}
				}, 100);


			});
		};
		selfScope.handleDomItemSubareaList = function () {
			//Subarealist used to append documents
			dom.okportalNumeriskSubareaList = dom.container.find(".okportal-numerisk__subarea-list");
		};
		selfScope.handleCollectionName = function () {

			// Set collectionname from page or parameter
			if ($(dom.numeriskResultsList)[0].dataset.agreementcollection !== "") {
				dom.paramsForWindowHistoryState.collectionName = $(dom.numeriskResultsList)[0].dataset.agreementcollection;
			} else {
				dom.paramsForWindowHistoryState.collectionName = dom.params.collectionName;
				dom.headline.text(`Numerisk ${(dom.params.collectionName !== "null" ? dom.params.collectionName : "")}`);
			}
		};
		selfScope.handleCopyUrl = function () {

			const copyBtns = dom.container.find(".document__actions-copyLink");
			copyBtns.on("click", e => {

				const currentBtn = $(e.currentTarget);
				currentBtn.addClass("-is-copied");
				// Find parent radioItem to get the agreementid
				const parentItem = currentBtn.closest(".accordion-box__content__item");
				const radioItem = parentItem.find("input[type=radio]");

				// Set current agreementid because we can have multiple open at once.
				dom.paramsForWindowHistoryState.agreementid = radioItem.attr("id");
				selfScope.SetWindowHistoryState();

				// Copy current page href
				var dummyInput = document.createElement('input'),
					text = window.location.href;

				document.body.appendChild(dummyInput);
				dummyInput.value = text;
				dummyInput.select();
				document.execCommand('copy');
				document.body.removeChild(dummyInput);

				window.setTimeout(() => {
					currentBtn.removeClass("-is-copied");
				}, 2000);

			});
		};
		selfScope.handleFav = function () {

			const favedBtns = dom.container.find(".document__actions-addFavorites");

			if (favedBtns.prop("tagName") !== "A") {
				favedBtns.on("click", e => {
					const currentBtn = $(e.currentTarget)[0];
					const contentId = currentBtn.dataset.contentid;
					const rowId = currentBtn.dataset.rowid;
					$(currentBtn).addClass("-is-loading");


					// If element is already in fav list
					if (!$(currentBtn).hasClass("-is-faved")) {
						// Setting favourite data
						const promise = selfScope.setFavourite(contentId);
						promise.then(data => {
							currentBtn.dataset.rowid = data;
							$(currentBtn).removeClass("-is-loading");
							$(currentBtn).addClass("-is-faved");
						}).catch(error => window.console.log(error));
					} else {
						// Removeing favourite data
						const promise = selfScope.removeFavourite(rowId);
						promise.then(() => {
							currentBtn.dataset.rowid = "";
							$(currentBtn).removeClass("-is-loading");
							$(currentBtn).removeClass("-is-faved");
						}).catch(error => window.console.log(error));
					}
				});
			} else {
				const loginModal = new dis.JqueryModal();
			}
		};
		selfScope.handleOpeningAgreement = function () {

			const accordionTriggerBtns = dom.container.find(".accordion-box__content__item__head");

			accordionTriggerBtns.on("click", e => {
				selfScope.openAgrement($(e.currentTarget));
			});
		};
		selfScope.handleOtherMaterial = function () {

			const materialBtns = dom.container.find(".document__actions-showOtherMaterial");

			materialBtns.on("click", e => {
				const materialBtn = $(e.currentTarget),
					btnContainer = materialBtn.parent(),
					materialsContainer = materialBtn.next(),
					agreementid = materialBtn.data("agreementid");

				if (materialBtn.hasClass("-is-active")) {
					materialsContainer.html("");
					materialBtn.removeClass("-is-active");
					materialBtn.find(".text").html("Vis andet relevant materiale");
				} else {
					btnContainer.addClass("-is-loading");
					const promise = selfScope.getOtherMaterial(agreementid);
					promise.then(data => {
						btnContainer.removeClass("-is-loading");

						if (data.length > 0) {
							materialBtn.find(".text").html("Skjul andet relevant materiale");
						}

						materialBtn.addClass("-is-active");

						data.forEach(function (element) {

							const elementUrl = selfScope.getotherMaterialUrlFromMaterialPath(element);

							materialsContainer.append("<a class='materiallinks' target='_blank' href='" + elementUrl + "'>" + element.headline + "</a>");
						});

					}).catch(error => window.console.log(error));
				}
			});

		};
		selfScope.openAgrement = function (element) {

			const index = $(element).data("documentlistid");
			const appendElement = $(element).next().find(".document");

			let documentsHtml = "";
			if ($(element).data("isReady") === undefined) {

				dom.documentList[index].forEach(function (document) {
					documentsHtml = documentsHtml + selfScope.templatingDocumentItem(document);
				});

				appendElement.append(documentsHtml);
			}

			$(element).data("isReady", true);
		};
		selfScope.openAgrementWithUrl = function () {
			const radiobox = $(`#${dom.params.agreementid}`);
			const currentAgreementElement = radiobox.next();
			if (currentAgreementElement.length > 0) {
				selfScope.openAgrement(currentAgreementElement);
			}

			if (radiobox.length > 0) {
				radiobox.prop('checked', true);

				// Scroll to top of list of articles, if it's outside viewport
				if (radiobox.next().offset().top > document.documentElement.scrollTop) {
					window.setTimeout(() => {
						$("html, body").animate({
							scrollTop: radiobox.next().offset().top
						}, 500);
					}, 500);
				}
			}
		};
		selfScope.getOtherMaterial = function (agreementId) {

			const url = `${location.origin}/umbraco/api/okportalcontent/getothermaterialbyagreementid?agreementId=${agreementId}`;

			return Promise.resolve($.ajax({
				url: url,
				type: "GET",
			}));
		};
		selfScope.getotherMaterialUrlFromMaterialPath = function (item) {
			const itemPath = item.path.split(',');

			const pathToItem = itemPath.slice(itemPath.length - 3, itemPath.length);
			const ariaId = pathToItem[0];
			const subareaId = pathToItem[1];
			const collectionName = item.collectionName;

			return `${location.origin}/numerisk?collectionName=${collectionName}&areaid=${ariaId}&subareaid=${subareaId}&agreementid=${item.id}`;
		};


		selfScope.onReady(init);
	};

	dis.OkportalNumerisk.prototype = new dis.BaseModule();
	dis.OkportalNumerisk.constructor = dis.OkportalNumerisk;


// This is where you define the global parameters you pass into your closure. You'll want to pass in any
// big stuff you'll need inside your script. Minor stuff can always be accessed through window.someVariable.
}(jQuery, dis));





